// NotesSection.js
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

const NotesSection = forwardRef(({ sheet, config, onDataChange }, ref) => {
    const { t } = useTranslation('labels');
    
    // Local state for notes data
    const [notes, setNotes] = useState(sheet?.Notes || '');
    const [acpm, setAcpm] = useState(sheet?.Acpm || false);

    // Expose data collection method to parent
    useImperativeHandle(ref, () => ({
        getData: () => ({
            Notes: notes,
            Acpm: acpm
        })
    }));

    const handleNotesChange = (e) => {
        setNotes(e.target.value);
        onDataChange();
    };

    const handleCheckboxChange = (e) => {
        setAcpm(e.target.checked);
        onDataChange();
    };

    return (
        <div className="card mt-0" style={{ backgroundColor: '#f2f2f2' }}>
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{t('notes')}</h5>

                {config.ACPM && (
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="acpmCheckbox"
                            checked={acpm}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label ms-1" htmlFor="acpmCheckbox">
                            ACPM
                        </label>
                    </div>
                )}
            </div>

            <div className="card-body">
                <textarea
                    style={{ border: '1px solid orange' }}
                    className="form-control"
                    rows="4"
                    value={notes}
                    onChange={handleNotesChange}
                    placeholder={t('notesPlaceholder')}
                ></textarea>
            </div>
        </div>
    );
});

export default NotesSection;
